import { defineDictionary } from "gemi/client";

// Component-scoped copy for the phone-browser app-download interstitial. Keys are
// named after the copy, en-US first (source + fallback), inline literal (gemi's
// Vite plugin needs a statically analysable call). `componentDictionaries.test.ts`
// enforces all 7 locales.
export const mobileAppInterstitialDict = defineDictionary({
  title: {
    "en-US": "Get the Folio app",
    "tr-TR": "Folio uygulamasını edinin",
    "de-DE": "Holen Sie sich die Folio-App",
    "es-ES": "Consigue la app de Folio",
    "fr-FR": "Obtenez l’application Folio",
    "it-IT": "Scarica l’app Folio",
    "ru-RU": "Установите приложение Folio",
  },
  subtitle: {
    "en-US":
      "Create product photos and pages on the go, right from your phone.",
    "tr-TR":
      "Ürün fotoğraflarınızı ve sayfalarınızı telefonunuzdan, her yerde oluşturun.",
    "de-DE":
      "Erstellen Sie Produktfotos und -seiten unterwegs, direkt vom Handy.",
    "es-ES":
      "Crea fotos y páginas de producto sobre la marcha, desde tu teléfono.",
    "fr-FR":
      "Créez des photos et des pages produit où que vous soyez, depuis votre téléphone.",
    "it-IT": "Crea foto e pagine prodotto ovunque, direttamente dal telefono.",
    "ru-RU": "Создавайте фото и страницы товаров где угодно, прямо с телефона.",
  },
  downloadApp: {
    "en-US": "Download the app",
    "tr-TR": "Uygulamayı indir",
    "de-DE": "App herunterladen",
    "es-ES": "Descargar la app",
    "fr-FR": "Télécharger l’application",
    "it-IT": "Scarica l’app",
    "ru-RU": "Скачать приложение",
  },
  logInPrompt: {
    "en-US": "Already have an account?",
    "tr-TR": "Zaten bir hesabınız var mı?",
    "de-DE": "Haben Sie schon ein Konto?",
    "es-ES": "¿Ya tienes una cuenta?",
    "fr-FR": "Vous avez déjà un compte ?",
    "it-IT": "Hai già un account?",
    "ru-RU": "Уже есть аккаунт?",
  },
  logIn: {
    "en-US": "Log in",
    "tr-TR": "Giriş yap",
    "de-DE": "Anmelden",
    "es-ES": "Iniciar sesión",
    "fr-FR": "Se connecter",
    "it-IT": "Accedi",
    "ru-RU": "Войти",
  },
  continueOnWeb: {
    "en-US": "Continue on web",
    "tr-TR": "Web ile devam et",
    "de-DE": "Im Web fortfahren",
    "es-ES": "Continuar en la web",
    "fr-FR": "Continuer sur le web",
    "it-IT": "Continua sul web",
    "ru-RU": "Продолжить в вебе",
  },
});
